import { useState } from "react";
import { appClients } from "@/mocks/home";

export default function AppSection() {
  const [activeKey, setActiveKey] = useState(appClients[0].key);
  const [notice, setNotice] = useState(false);

  const active = appClients.find((c) => c.key === activeKey) ?? appClients[0];

  const handleGet = () => {
    setNotice(true);
    window.setTimeout(() => setNotice(false), 3200);
  };

  return (
    <section id="app" className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            App 下载
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            51视频 App 下载与客户端说明
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            客户端安装后，桌面图标就是稳定入口，不用每次重新输入网址。
            安卓、iOS 与电视TV 三个版本功能相近，按你的设备选择对应版本即可。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
              {appClients.map((c) => (
                <button
                  key={c.key}
                  type="button"
                  onClick={() => setActiveKey(c.key)}
                  className={`flex-1 whitespace-nowrap rounded-full px-4 py-2.5 text-sm transition-colors ${
                    activeKey === c.key
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {c.label}
                </button>
              ))}
            </div>

            <div className="mt-5 rounded-2xl border border-background-200 bg-background-100 p-5 md:p-7">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div className="flex items-center gap-3">
                  <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                    <i className="ri-apps-2-line text-2xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-foreground-950">
                      51视频 · {active.label}
                    </h3>
                    <p className="text-xs text-foreground-600">{active.platform}</p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                  <i className="ri-verified-badge-line" aria-hidden="true"></i>
                  版本 {active.version}
                </span>
              </div>

              <dl className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
                <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                  <dt className="text-xs text-foreground-600">安装包大小</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-950">{active.size}</dd>
                </div>
                <div className="rounded-lg border border-background-200 bg-background-50 p-3">
                  <dt className="text-xs text-foreground-600">最近更新</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-950">{active.updated}</dd>
                </div>
                <div className="col-span-2 rounded-lg border border-background-200 bg-background-50 p-3 sm:col-span-1">
                  <dt className="text-xs text-foreground-600">文件标识</dt>
                  <dd className="mt-1 truncate text-sm font-medium text-foreground-950">
                    {active.file}
                  </dd>
                </div>
              </dl>

              <ul className="mt-6 space-y-2.5">
                {active.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <i className="ri-check-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
                <button
                  type="button"
                  onClick={handleGet}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-download-2-line text-base" aria-hidden="true"></i>
                  获取安装包
                </button>
                <a
                  href="#address"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-links-line text-base" aria-hidden="true"></i>
                  复制官网入口
                </a>
              </div>

              {notice && (
                <div className="mt-4 flex items-start gap-2.5 rounded-lg border border-accent-300 bg-accent-50 px-4 py-3">
                  <i className="ri-information-line mt-0.5 text-accent-700" aria-hidden="true"></i>
                  <p className="text-xs leading-relaxed text-foreground-800">
                    安装包由官方入口分发，本页不直接存放文件。请先在上方「最新地址」复制官网主入口，
                    进入官方页面后选择对应版本下载，避免从陌生来源安装。
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative mx-auto h-[360px] w-full max-w-md overflow-hidden rounded-2xl border border-background-200 bg-background-100 md:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20product%20mockup%20of%20a%20smartphone%20standing%20upright%20showing%20a%20dark%20video%20streaming%20app%20interface%20with%20warm%20orange%20accent%20buttons%20and%20thumbnail%20grid%2C%20soft%20neutral%20beige%20studio%20background%2C%20minimal%20modern%20tech%20presentation%2C%20soft%20shadow%20free%20even%20lighting&width=900&height=1100&seq=video51-app-1&orientation=portrait"
                alt="51视频移动客户端界面在手机上的展示示意"
                className="h-full w-full object-top"
              />
            </div>
            <div className="mx-auto mt-5 grid max-w-md grid-cols-3 gap-3">
              <div className="rounded-lg border border-background-200 bg-background-100 p-3 text-center">
                <i className="ri-shield-check-line text-lg text-primary-500" aria-hidden="true"></i>
                <p className="mt-1 text-xs text-foreground-700">官方签名</p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-3 text-center">
                <i className="ri-speed-up-line text-lg text-primary-500" aria-hidden="true"></i>
                <p className="mt-1 text-xs text-foreground-700">线路优选</p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-3 text-center">
                <i className="ri-refresh-line text-lg text-primary-500" aria-hidden="true"></i>
                <p className="mt-1 text-xs text-foreground-700">增量更新</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}